export const getFeatureFlags = () =>
  // eslint-disable-next-line no-underscore-dangle
  window.__WTR_COMMON__.featureFlags;
